module.exports = __webpack_public_path__ + "img/xiaohui7.1af1c070.jpg";